module.exports = __webpack_public_path__ + "img/energy_icon3.e683a6f6.png";